/**
 * WiFi Group — section reveal controller.
 * Single shared IntersectionObserver for every [data-wifi-reveal] element.
 * No external library; respects prefers-reduced-motion by no-op (CSS handles the rest).
 */
(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const targets = document.querySelectorAll('[data-wifi-reveal]');
  if (!targets.length) return;

  if (prefersReduced || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const group = entry.target.closest('[data-wifi-reveal-group]');
        if (group) group.classList.add('is-visible');
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  targets.forEach((el, index) => {
    el.style.setProperty('--wifi-reveal-index', index % 6);
    observer.observe(el);
  });
})();
